// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__14jVV","additionalInfo":"AgreementModal_additionalInfo__2nFxw"};